(function () {

  'use strict';

  eclipseApp.factory('prepaidRegisteredCCInfoService', function() {

    var firstName = null,
      lastName = null,
      maskedCCNumber = null,
      cardScheme = null,
      tokenizedCCNumber = null,
      month = null,
      year = null,
      creditCardRegistrationStatus = null;

    function setFirstName(data) {
      firstName = data;
    }

    function getFirstName() {
      return firstName;
    }

    function setLastName(data) {
      lastName = data;
    }

    function getLastName() {
      return lastName;
    }

    function setMaskedCCNumber(data) {
      maskedCCNumber = data;
    }

    function getMaskedCCNumber() {
      return maskedCCNumber;
    }

    function setCardScheme(data) {
      cardScheme = data;
    }

    function getCardScheme() {
      return cardScheme;
    }

    function setTokenizedCCNumber(data) {
      tokenizedCCNumber = data;
    }

    function getTokenizedCCNumber() {
      return tokenizedCCNumber;
    }

    function setMonth(data) {
      month = data;
    }

    function getMonth() {
      return month;
    }

    function setYear(data) {
      year = data;
    }

    function getYear() {
      return year;
    }

    function setCreditCardRegistrationStatus(data) {
      creditCardRegistrationStatus = data;
    }

    function getCreditCardRegistrationStatus() {
      return creditCardRegistrationStatus;
    }

    return {
      setFirstName: setFirstName,
      getFirstName: getFirstName,
      setLastName: setLastName,
      getLastName: getLastName,
      setMaskedCCNumber: setMaskedCCNumber,
      getMaskedCCNumber: getMaskedCCNumber,
      setCardScheme: setCardScheme,
      getCardScheme: getCardScheme,
      setTokenizedCCNumber: setTokenizedCCNumber,
      getTokenizedCCNumber: getTokenizedCCNumber,
      setMonth: setMonth,
      getMonth: getMonth,
      setYear: setYear,
      getYear: getYear,
      setCreditCardRegistrationStatus: setCreditCardRegistrationStatus,
      getCreditCardRegistrationStatus: getCreditCardRegistrationStatus
    };

  });

})();
